class FormValidator {
    constructor(v) {
      this.ruleSet = v
    }
    validateFields = (data, field = '') => {
      if (field.length) data = { [field]: data }
      let errorsmsg = {};
      const inputs = field ? [field] : Object.keys(this.ruleSet)
      //debugger;
      inputs.forEach(input => {
        if (this.ruleSet.hasOwnProperty(input) && data.hasOwnProperty(input)) {
          const field_value = (typeof str === 'string') ? data[input].trim() : data[input]
          //Check all validators
          for (let [key, value] of Object.entries(this.ruleSet[input])) {
            //console.log(key, value);
            if (key === 'empty') {
              if (!field_value.length) errorsmsg[input] = value
            } else if (value.validator(field_value)) {
              errorsmsg[input] = value.message
            }
          }
        } else {
          console.log('Field not found in validator set.')
        }
      });
      //console.log('errorsmsg',errorsmsg);
      return errorsmsg;
    };
  }
  export default FormValidator;